import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';
import { getPublicAsset } from 'base/shared/Utils';
import { BADI_COLORS, Flex, Text, Button, BUTTON_TYPES } from '@badi/badi-components';
import { locale } from 'base/shared/Localization';
import { Link } from 'react-router';
import { getInboxPath } from 'Sections/inbox/routes';
import UserMenu from 'components/Layout/TopBar/components/user-menu';

import Logo from 'app/Sections/Home/components/Logo';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${(props) => (props.$isScrolled ? 'rgb(51, 51, 51)' : 'transparent')};
  transition: background-color 0.3s ease;
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 1rem;
  }
`;

const MenuButton = styled(Button)`
  color: white !important;
  border: 1px solid white !important;
  padding: 6px 12px !important;
  height: auto !important;

  &:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
  }
`;

const MenuLink = styled(Link)`
  text-decoration: none;
  color: white;
  font-weight: 500;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;

const UserMenuWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LoginButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export default function Header({
  isLister,
  isLoggedIn,
  logout,
  onListYourProperty,
  openLogin,
  openMyProfile,
  picture,
  switchUser,
}) {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleListRoomClick = () => {
    // Navegar a la página correcta según el idioma
    const currentLocale = locale();
    const url =
      currentLocale === 'es' ? 'https://badi.com/es/anunciantes' : 'https://badi.com/listers';
    window.open(url, '_blank');
  };

  const handleManagePropertyClick = () => {
    // Navegar a la página correcta según el idioma
    const currentLocale = locale();

    const url =
      currentLocale === 'es'
        ? `https://plus.badi.com/${currentLocale}/propietarios/?utm_source=marketplace&utm_medium=web&utm_campaign=listyourproperty`
        : `https://plus.badi.com/owners/?utm_source=marketplace&utm_medium=web&utm_campaign=listyourproperty`;
    window.open(url, '_blank');
  };

  const switchToLister = () => switchUser('lister');

  return (
    <HeaderContainer $isScrolled={isScrolled}>
      <HeaderContent>
        <Logo color={BADI_COLORS.NEUTRAL.NEUTRAL_00} dataQa="topbar-logo" />
        <Flex alignItems="center" gutter={1.5}>
          <MenuButton
            data-qa="topbar-seeker-menu-manage-property"
            onClick={handleManagePropertyClick}
            variant={BUTTON_TYPES.SECONDARY}
          >
            <Text body="12-Medium" color="white">
              {translate('topbar.element.manageproperty.title')}
            </Text>
          </MenuButton>
          <MenuButton
            data-qa="topbar-seeker-menu-list-rent"
            onClick={handleListRoomClick}
            variant={BUTTON_TYPES.SECONDARY}
          >
            <Text body="12-Medium" color="white">
              {translate('topbar.element.listproperty.title')}
            </Text>
          </MenuButton>
          {isLoggedIn ? (
            [
              <MenuLink
                as={Link}
                data-qa="topbar-seeker-menu-inbox"
                key="inbox"
                to={getInboxPath()}
              >
                <Text body="14-Medium" color="white">
                  {translate('topbar.element.inbox')}
                </Text>
              </MenuLink>,
              <UserMenuWrapper key="menu">
                <UserMenu
                  data-qa="topbar-seeker-menu"
                  logout={logout}
                  mode="seeker"
                  picture={picture}
                  switchMode={isLister ? switchToLister : null}
                />
              </UserMenuWrapper>,
            ]
          ) : (
            <LoginButton
              data-qa="topbar-public-menu-login"
              onClick={() => {
                console.log('Login button clicked, openLogin function:', typeof openLogin);
                if (openLogin) {
                  openLogin();
                } else {
                  console.error('openLogin is not a function!');
                }
              }}
            >
              <img
                alt="login"
                style={{ height: 32, width: 32 }}
                src={getPublicAsset('icons/home/login.svg')}
              />
            </LoginButton>
          )}
        </Flex>
      </HeaderContent>
    </HeaderContainer>
  );
}
